import { render, staticRenderFns } from "./ObjectStoreStorageOverview.vue?vue&type=template&id=79b082ce"
import script from "./ObjectStoreStorageOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreStorageOverview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports